var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user" },
    [
      !_vm.selectedUser
        ? _c("div", { staticClass: "no user-card" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("SelectUser")))])
          ])
        : _vm._e(),
      _vm._v(" "),
      !!_vm.selectedUser
        ? _c(
            "div",
            { staticClass: "user-info-container" },
            [
              _c("object-main-info", {
                attrs: {
                  fields: _vm.fields,
                  identifier: _vm.user ? _vm.user.name : "",
                  "identifier-label": _vm.$t(""),
                  "editing-data": _vm.editingData,
                  "show-edit-button":
                    _vm.actionToExecute !== "addUser" &&
                    _vm.userHasPermission("user_update"),
                  "card-label": _vm.$t(_vm.cardLabel),
                  height: _vm.editingData ? "47%" : "29%",
                  "submit-button-label": _vm.submitButtonLabel,
                  "required-fields-filled": _vm.requiredFieldsAreFilled,
                  showEditActionButtons: "false"
                },
                on: {
                  "toggle-edit": _vm.toggleEdit,
                  "update-object": _vm.updateUser,
                  "save-object": _vm.saveObject,
                  "cancel-edit": function($event) {
                    _vm.discardChangesDialogIsOpen = true
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "object-image-slot",
                      fn: function() {
                        return [
                          _c("img", {
                            staticClass: "user-logo",
                            attrs: {
                              src: _vm.user ? _vm.user.image : null,
                              alt: "User Image Icon"
                            }
                          })
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "buttons-before-edit-slot",
                      fn: function() {
                        return [
                          _vm.actionToExecute !== "addUser"
                            ? _c("custom-button", {
                                attrs: {
                                  icon: "mdi-lock",
                                  "icon-size": 13,
                                  height: "20px",
                                  width: "20px",
                                  "button-styling": _vm.buttonStyling
                                },
                                on: { buttonClick: _vm.toggleLock }
                              })
                            : _vm._e()
                        ]
                      },
                      proxy: true
                    },
                    _vm.editingData
                      ? {
                          key: "before-fields-slot",
                          fn: function() {
                            return [
                              _c(
                                "div",
                                { staticClass: "edit-image-container" },
                                [
                                  _c("input", {
                                    ref: "file",
                                    staticStyle: { display: "none" },
                                    attrs: {
                                      type: "file",
                                      id: "file",
                                      accept: "image/*"
                                    },
                                    on: { change: _vm.previewFile }
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticClass: "user-logo",
                                    attrs: {
                                      src: _vm.user ? _vm.user.image : null,
                                      alt: "User Image Icon"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("custom-button", {
                                    attrs: {
                                      height: "20px",
                                      label: _vm.$t("AddPhoto"),
                                      "button-styling": Object.assign(
                                        {},
                                        _vm.buttonStyling,
                                        {
                                          padding: "0 5px",
                                          "margin-right": "7px",
                                          "font-size": "9px"
                                        }
                                      )
                                    },
                                    on: { buttonClick: _vm.submitFile }
                                  }),
                                  _vm._v(" "),
                                  _c("custom-button", {
                                    attrs: {
                                      icon: "mdi-delete",
                                      "icon-size": 13,
                                      width: "20px",
                                      height: "20px",
                                      "button-styling": _vm.buttonStyling
                                    },
                                    on: { buttonClick: _vm.deleteUserImage }
                                  })
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      : null
                  ],
                  null,
                  true
                )
              }),
              _vm._v(" "),
              _c("user-specific-info", {
                key: _vm.updateSpecificInfoKey,
                ref: "userSpecificInfo",
                attrs: {
                  selectedUser: _vm.selectedUser,
                  user: _vm.user,
                  "editing-data": _vm.editingData,
                  "required-fields-filled": _vm.requiredFieldsAreFilled,
                  "submit-button-label": _vm.submitButtonLabel
                },
                on: {
                  "update-required-field": function($event) {
                    _vm.specificRequiredFieldsAreFilled = $event
                  },
                  "cancel-edit": function($event) {
                    _vm.discardChangesDialogIsOpen = true
                  },
                  "save-user": function($event) {
                    _vm.saveChangesDialogIsOpen = true
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("loading-spinner", {
        staticStyle: { position: "absolute" },
        attrs: {
          active: _vm.loading,
          "is-full-page": false,
          color: "var(--app-primary-base)"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.saveChangesDialogIsOpen,
          title: _vm.$t("SaveChanges"),
          content: _vm.$t("SaveChangesContent"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-content-save",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.saveObject,
          secondaryAction: function($event) {
            _vm.saveChangesDialogIsOpen = false
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.discardChangesDialogIsOpen,
          title: _vm.$t("DiscardChanges"),
          content: _vm.$t("ClusterCreationConfirmation"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-delete",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.cancelEdit,
          secondaryAction: function($event) {
            _vm.discardChangesDialogIsOpen = false
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.tokenChangesDialogIsOpen,
          title: _vm.$t("RevokeTokenMessage.RevokeToken"),
          content: _vm.messageContentRevokeToken,
          extraContent: _vm.messageExtraContentRevokeToken,
          extraContentStyle: _vm.messageExtraContentStyling,
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-lock-open",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.revokeToken,
          secondaryAction: _vm.cancelRevokeToken
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e8d7012", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e8d7012","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/Accounts/User.vue
// module id = null
// module chunks = 